import React, { useState } from "react";
import "./style.css";

export default function ProductCard({
  name,
  uid,
  slug,
  image,
  sku,
  selected,
  onClickFn,
  sale_price,
  regular_price,
  isAdmin,
  onClickFn2,
  fob_price,
  spiff,
  qty,
  stock,
  showFobPrice,
  showLandedCost,
  landedCost,
  spiffChecked = false,
  loChecked = false,
  spiffValueChecked = false,   // ⬅️ NEW
  onSpiffChange,
  onLoChange,
  onSpiffValueChange,         // ⬅️ NEW
}) {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleSpiffChange = (e) => {
    if (onSpiffChange) onSpiffChange(e.target.checked);
  };

  const handleLoChange = (e) => {
    if (onLoChange) onLoChange(e.target.checked);
  };

   const handleSpiffValueChange = (e) => {          // ⬅️ NEW
    if (onSpiffValueChange) onSpiffValueChange(e.target.checked);
  };


  return (
    <div className={selected ? "product_card_1 selected" : "product_card_1"}>
      <div className="image_section">
        {!imageLoaded && <div className="image_shimmer" />}
        <img
          src={image}
          alt={name}
          style={{ display: imageLoaded ? "block" : "none" }}
          onLoad={() => setImageLoaded(true)}
        />

        {/* Custom styled badge toggles */}
        {selected && (

          <div className="checkbox_overlay_top_right">
            {spiffChecked && isAdmin && <label className={`custom_badge_checkbox ${spiffValueChecked ? "active spiffvalue" : ""}`}>
              <input
                type="checkbox"
                checked={spiffValueChecked}
                onChange={handleSpiffValueChange}
              />
              <span className="badge_indicator"></span>
              <span className="badge_text">SPIFF W/V</span>
            </label>}


            {isAdmin && <label className={`custom_badge_checkbox ${spiffChecked ? "active spiff" : ""}`}>
              <input
                type="checkbox"
                checked={spiffChecked}
                onChange={handleSpiffChange}
              />
              <span className="badge_indicator"></span>
              <span className="badge_text">SPIFF</span>
            </label>}

            <label className={`custom_badge_checkbox ${loChecked ? "active lo" : ""}`}>
              <input
                type="checkbox"
                checked={loChecked}
                onChange={handleLoChange}
              />
              <span className="badge_indicator"></span>
              <span className="badge_text">LO</span>
            </label>

          </div>
        )}

        <div className="buttons_set_1">
          <button onClick={onClickFn2}>Quick View</button>
          <button
            onClick={onClickFn}
            className={selected ? "selection_btn selected" : "selection_btn"}
          >
            {selected ? "Unselect" : "Select"}
          </button>
        </div>
      </div>

      <p>SKU : {sku}</p>
      <h3>{name}</h3>

    <div className="spiff_price">
      <div>
           {sale_price ? (
        <>
          <span className="price">${sale_price}</span>
          {regular_price && (
            <span
              className="old_price"
              style={{ textDecoration: "line-through", marginLeft: "5px" }}
            >
              ${regular_price}
            </span>
          )}
        </>
      ) : (
        <span className="price">${regular_price}</span>
      )}
      </div>

      {/* Replace {spiff} with this: */}
{spiff !== undefined && spiff !== null && spiff !== "" && (
  <div className="spiff_display_info">
    <span className="spiff_label">SPIFF :</span> {spiff}
  </div>
)}

    </div>
      <div className="other_info_Section_2">
        {showLandedCost && landedCost && (
          <div className="lanced_price_here_2">LC : ${landedCost}</div>
        )}
        {showFobPrice && fob_price && (
          <div className="fob_price_here_2">FOB : ${fob_price}</div>
        )}
      </div>

      <div className="other_info_Section">
        <div className="section_ois">{qty && `QTY : ${qty}`}</div>
        <div className="section_ois" style={{ textAlign: "end" }}>
          {stock && (
            <span
              className={
                stock.toLowerCase() === "instock"
                  ? "stock-label in-stock"
                  : stock.toLowerCase() === "outstock" ||
                    stock.toLowerCase() === "outofstock"
                    ? "stock-label out-stock"
                    : "stock-label"
              }
            >
              {stock.toLowerCase() === "instock"
                ? "In Stock"
                : stock.toLowerCase() === "outstock" ||
                  stock.toLowerCase() === "outofstock"
                  ? "Out Stock"
                  : stock}
            </span>
          )}
        </div>
      </div>
    </div>
  );
}